import React from "react";
import "./Pagination.scss";
import { LeftIcon, RightIcon } from "../../assets/icons";

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 50, 100];

function Pagination({
  currentPage,
  recordsPerPage,
  totalRecords,
  onPageChange,
  onRecordsPerPageChange,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
}) {
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = (currentPage - 1) * recordsPerPage + 1;

  const handlePageSizeChange = (e) => {
    const next = Number(e.target.value);
    if (Number.isFinite(next) && onRecordsPerPageChange) {
      onRecordsPerPageChange(next);
    }
  };

  const handleNextPage = () => {
    const nextPage = currentPage + 1;
    onPageChange(nextPage);
  };

  const handlePrevPage = () => {
    const prevPage = currentPage - 1;
    onPageChange(prevPage);
  };

  const resolvedPageSize = pageSizeOptions.includes(Number(recordsPerPage))
    ? recordsPerPage
    : pageSizeOptions[0];

  return (
    <>
      <div className="pagination">
        {/* Pagination Info */}
        <div className="pagination__info">
          <div className="pagination__current-page">{indexOfFirstRecord}</div>
          <div className="pagination__separator">-</div>
          <div className="pagination__records-end">
            {indexOfLastRecord > totalRecords
              ? totalRecords
              : indexOfLastRecord}
          </div>
          <div className="pagination__separator">di</div>
          <div className="pagination__total-records">{totalRecords}</div>
          <div className="pagination__label">elementi</div>
          <div className="pagination__per-page">
            {typeof onRecordsPerPageChange === "function" ? (
              <>
                <select
                  className="pagination__page-size-select"
                  aria-label="Elementi per pagina"
                  value={resolvedPageSize}
                  onChange={handlePageSizeChange}
                >
                  {pageSizeOptions.map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
                <span className="pagination__per-page-prompt">per pagina</span>
              </>
            ) : (
              <div className="pagination__per-page-label">{recordsPerPage}</div>
            )}
          </div>
        </div>
        {/* PAgination Info End*/}
        {/* Pagination Nav */}
        <div className="pagination__nav">
          <div
            className={`pagination__nav-icon ${
              currentPage === 1 ? "disabled" : ""
            }`}
          >
            <div
              alt="example2"
              onClick={currentPage !== 1 ? handlePrevPage : undefined}
            >
              <LeftIcon fillColor="var(--archeo-color)" />
            </div>
          </div>
          <div className="pagination__nav-info">
            <div className="pagination__nav-label">Pagina</div>
            <div className="pagination__nav-page">{currentPage}</div>
          </div>
          <div
            className={`pagination__nav-icon ${
              indexOfLastRecord >= totalRecords ? "disabled" : ""
            }`}
          >
            <div
              alt="example3"
              onClick={
                indexOfLastRecord < totalRecords ? handleNextPage : undefined
              }
            >
              <RightIcon fillColor="var(--archeo-color)" />
            </div>
          </div>
        </div>
        {/* Pagination Nav End*/}
      </div>
    </>
  );
}

export default Pagination;
